import { invokeApi } from "../../../bl_libs/invokeApi";

export const _list_shipment_transit_by_shipment = async (shipment_id) => {
  let requestObj = {
    path: `api/shipment_transit/list_shipment_transit/${shipment_id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _add_shipment_transit = async (data) => {
  const requestObj = {
    path: `api/shipment_transit/add_shipment_transit`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _delete_shipment_transit = async (data, shipment_id) => {
  const requestObj = {
    path: `api/shipment_transit/delete_shipment_transit/${shipment_id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _update_shipment_transit = async (postData, shipment_id) => {
  const requestObj = {
    path: `api/shipment_transit/edit_shipment_transit/${shipment_id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: postData,
  };
  return invokeApi(requestObj);
};

export const _detail_shipment = async (id) => {
  const requestObj = {
    path: `api/shipment/detail_shipment/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
